import React, { useState } from "react";
import { Spin } from "antd";

import SbIncomeGraph from "../card/sbIncomeGraph";
import SbIncomeDetailList from "../card/sbIncomeDetailList";

const SbIncomeDetail = () => {
  const [loading, setLoading] = useState(false);

  return (
    <div className="p-6">
      <h2 className="text-xl font-semibold text-[#32B7C2] mb-4">
        📋 Орлогын задаргаа
      </h2>
      <Spin spinning={loading}>
        <div className="grid gap-6">
          <SbIncomeDetailList />
        </div>
      </Spin>
    </div>
  );
};

export default SbIncomeDetail;
